import script from "./districtChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./districtChart.vue?vue&type=script&lang=ts&setup=true"

import "./districtChart.vue?vue&type=style&index=0&id=3d2bb10a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2bb10a"]])

export default __exports__